import { render } from "./ActionButton.vue?vue&type=template&id=471dca42&scoped=true&bindings={\"cssClass\":\"props\",\"buttonClicked\":\"options\"}"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=471dca42&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-471dca42"

export default script